
import { Component, Vue } from "vue-property-decorator";
import LsDialog from "@/components/ls-dialog.vue";
import { apiPaymentConfigGetList, apiSettingsPayConfigSetStatus } from "@/api/setting";
@Component({
    components: {
        LsDialog,
    },
})
export default class PayTemplate extends Vue {
    /** S Data **/
    paymentConfigData: Array<Object> = [];
    /** E Data **/

    /** S Methods **/

    // 更改支付状态
    updateStatus(row: any) {
        apiSettingsPayConfigSetStatus({
            pay_way: row.pay_way,
            status: row.status,
        }).then(res=>{
            this.getPaymentConfigList()
        })
    }

    // 获取支付方式数据
    getPaymentConfigList() {
        apiPaymentConfigGetList()
            .then((res: any) => {
                this.paymentConfigData = res.lists;
            })
            .catch(() => {
                this.$message.error("数据初始化失败，请刷新重载！");
            });
    }

    goPayConfigEdit(row: any) {
        this.$router.push({
            path: "/setting/payment/pay_config_edit",
            query: {
                id: row.id,
                pay_way: row.pay_way
            },
        });
    }
    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.getPaymentConfigList();
    }
}
